import { OreHeading, OreInput, OreStack } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { Step1Form } from '@/AutoEnrollment/ui/hooks'
import { IBAN_MAX_LENGTH, iban } from '@/Shared/domain'
import { handleErrors } from '@/Shared/ui/form'

export const Step1PaymentAccountData = (): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState } = useFormContext<Step1Form>()
  const { onChange, ...rest } = register('iban')
  const { errors } = handleErrors(formState)

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(AutoEnrollmentTranslation.paymentAccountData.title)}
      </OreHeading>
      <OreInput
        {...rest}
        {...errors('iban')}
        id="iban"
        label={t(AutoEnrollmentTranslation.paymentAccountData.data.iban.label)}
        placeholder={t(
          AutoEnrollmentTranslation.paymentAccountData.data.iban.placeholder,
        )}
        required
        maxLength={IBAN_MAX_LENGTH}
        onChange={e => {
          e.target.value = iban(e.target.value)
          onChange(e)
        }}
      />
    </OreStack>
  )
}
